/* eslint-disable @typescript-eslint/camelcase */
import React, { useCallback, Dispatch, useRef, useMemo, useState, useEffect } from 'react';
import { Form } from '@unform/web';
import { FiArrowRight, FiArrowLeft, FiMail } from 'react-icons/fi';
import { FormHandles } from '@unform/core';
import axios from 'axios';
import pagarme from 'pagarme';
import { type } from 'os';
import { Link, useParams } from 'react-router-dom';
import api from '../../../../services/api';
import MaskedInput from '../../../../components/Forms/MaskedInput';
import Input from '../../../../components/Forms/Input';
import Button from '../../../../components/Button';
import SelectSimple from '../../../../components/Forms/SelectSimple';

import { eventName, gateKey } from '../../../../config';
import imgBoleto from '../../../../assets/barcode.png';

import { AnimatedDiv } from '../../styles';
import { Content } from './styles';
import { useModal } from '../../../../hooks/Modal';
import { useToast } from '../../../../hooks/Toast';

import Whatsapp from '../../../../components/Whatsapp';

import { BuyContext } from '../../index';
import Loader from '../../../../components/Loader';
import format from '../../../../utils/format';
import {
  ResponseMessage,
  IResponseMessage,
} from '../../../../components/ResponseMessage';

import UpdateUserContainer from '../../../../components/UserUpdateComponent';
import { useAuth } from '../../../../hooks/Auth';
import { useLanguage } from '../../../../hooks/Language';
import { FaCreditCard, FaReceipt } from 'react-icons/fa';
import AtualizarCadastroContainer from '../AtualizarCadastro';

interface IComponentProps {
  step: number[];
  setStep: Dispatch<React.SetStateAction<number[]>>;
  buyContext: BuyContext;
  setBuyContext: Dispatch<React.SetStateAction<BuyContext>>;
}

interface ICardProps {
  id?: string;
  card_holder_name: string;
  card_expiration_date: string;
  card_number: string;
  card_cvv: string;
  installments?: number;
  document_type: string;
}

interface IInstallment {
  label: string;
  value: string;
}

interface IParams {
  payment_hash : string;
}

const PaymentConfirmation: React.FC = () => {

  const [buyContext,setBuyContext] = useState<Record<string,any>>({});
  const [update, setUpdate] = useState(false);
  const [loading, setLoading] = useState(true);
  const [ready, setReady] = useState(false);
  const formRef = useRef<FormHandles>(null);

  const[productNotFound,setProductNotFound] = useState(false);

  const {payment_hash} = useParams<IParams>();

  const { addToast } = useToast();
  const { addModal } = useModal();

  const [responseMessage, setResponseMessage] = useState(
    {} as IResponseMessage,
  );

    const {translate} = useLanguage();

  const {user} = useAuth();

  const load = async(hash) => {

    if(user){

    try{
    const paymentInfo = await api.get(`/verify-sale/${payment_hash}`);

    if(!paymentInfo){
      setProductNotFound(true);
      return;
    }

    const {payment_method_id,boleto_url} = paymentInfo.data;

    if(payment_method_id === 2){
    setResponseMessage({
      icon: () => <FiMail />,
      active: true,
      title: 'Inscrição realizada com sucesso!',
      type: 'success',
      description: (
        <>
          {translate('Clique no botão abaixo para acessar o boleto.')}
          <br />
          <a href={boleto_url} title="boleto">
            <Button type="button">{translate('Boleto')} </Button>
          </a>
          <br />
          {translate('Ou no link abaixo')}:
          <br />
          <a href={boleto_url} title={translate('boleto')}>
            {boleto_url}
          </a>
          <br />
          <div style={{display:'flex', justifyContent:'center', width:'100%'}}>
          <Link to="/login">{translate('Login')}</Link>
          </div>
        </>
      ),
    });
  }
  else{
    setResponseMessage({
      icon: () => <FiMail />,
      active: true,
      title: translate('Inscrição realizada com sucesso!'),
      type: 'success',
      description: (
        <>
          {translate('Sua inscrição foi confirmada!')}
          <br />
          {translate('Para acessar a plataforma, clique no botão abaixo')}
 
          <Link style={{display:'flex', justifyContent:'center', width:'100%', marginTop:'10px'}} to="/login">
            <Button type="button">{translate('Login')} </Button>
          </Link>
 
        </>
      ),
    });

  }

  setLoading(false);

    setReady(true);

  } catch (err) {
    
    setLoading(false);
   setProductNotFound(true);
    addToast({type:"error", title: "Erro ao identificar compra."});
    return;
  }
  

}
  }

  useEffect(() => {

    if(!payment_hash){
       window.location.href = '/planos';
       return;
    }

   
    load(payment_hash);
    setLoading(false);

  },[payment_hash])






  if(!user){
    return         <div className="onlineMessage" style={{display:'flex', width:'auto', maxWidth: '400px',margin: '0px auto', flexDirection:'column',border: '2px solid #fff', borderRadius: '20px',padding: '20px',marginTop:'100px', alignItems:'center', justifyContent: 'center'}}>
         
    <h2 className="defaultMarked"><div/>{translate('Falha ao completar ação')}</h2>
    <p style={{color: '#fff', textAlign: 'center',marginTop: '20px'}}>
      {translate(
        'Você precisa estar logado para finalizar a incrição.',
      )}
    </p><br/><br/>
    <Link to="/planos">
      <button className="shadowGreyButton" type="button">
        {' '}
        {translate('Voltar')}
      </button>
    </Link>
  </div>
  }

  if(productNotFound){
   return <div className="onlineMessage" style={{display:'flex', width:'auto', maxWidth: '400px',margin: '0px auto', flexDirection:'column',border: '2px solid #fff', borderRadius: '20px',padding: '20px',marginTop:'100px', alignItems:'center', justifyContent: 'center'}}>
         
    <h2 className="defaultMarked">{translate('Erro ao identificar sua inscrição')}</h2>
    <p style={{color: '#fff', textAlign: 'center',marginTop: '20px'}}>
      {translate(
        'Tente recarregar a página, ou entre em contato com a organização.',
      )}
    </p><br/><br/>
    <Link to="/planos">
      <button className="shadowGreyButton" type="button">
        {' '}
        {translate('Voltar')}
      </button>
    </Link>
  </div>
  }

  return (
    <>
      {loading && <Loader message={`${translate('Carregando')}...`} />}
     {ready && <AnimatedDiv visible={true}>
        {responseMessage.active === true && (
          <ResponseMessage
            active
            type={responseMessage.type}
            title={responseMessage.title}
            description={responseMessage.description}
          />
        )}
        
      </AnimatedDiv>}
    </>
  );
};

export default PaymentConfirmation;
